import React, { useState } from 'react';

import { Flexbox, IconButton, Text, color } from '@morressier/ts';

import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import styled from 'styled-components';

export const StyledAccordion = styled(Flexbox).attrs({
  flexDirection: 'column',
})`
  width: 100%;
  border: 1px solid ${color('lightGrey')};
  border-radius: 4px;
  background: white;
`;

export const StyledAccordionHeader = styled(Flexbox).attrs({
  flexDirection: 'column',
})`
  width: 100%;
  margin: 1rem;
`;

const StyledAccordionContent = styled(Flexbox).attrs({
  flexDirection: 'column',
})`
  width: 100%;
`;

const StyledAccordionDivider = styled.hr`
  border: none;
  height: 1px;
  background-color: ${color('lightGrey')};
  width: 100%;
  margin: 0;
`;

export const AccordionHeader = ({ title, subtitle }) => (
  <StyledAccordionHeader style={{ margin: '1rem' }} justifyContent="space-between">
    <Text size="body1_new" fontWeight="semiBold">
      {title}
    </Text>
    <Text size="body1_new">{subtitle}</Text>
  </StyledAccordionHeader>
);

type AccordionProps = {
  open?: boolean;
  header: React.ReactNode;
  children?: React.ReactNode;
  ariaTitle: string;
};

const Accordion = ({ open, header, children, ariaTitle }: AccordionProps) => {
  // TODO: make this unopinionated (no-padding/margin and move to storybook)
  const [isOpen, setIsOpen] = useState(open || false);
  return (
    <StyledAccordion>
      <Flexbox flexDirection="row">
        {header}{' '}
        <IconButton
          style={{ margin: '1rem' }}
          color="secondaryBrand"
          onClick={() => setIsOpen(!isOpen)}
          aria-label={isOpen ? `close ${ariaTitle}` : `open ${ariaTitle}`}
        >
          {isOpen ? <FaChevronUp /> : <FaChevronDown />}
        </IconButton>
      </Flexbox>
      {isOpen && (
        <>
          <StyledAccordionDivider /> <StyledAccordionContent>{children}</StyledAccordionContent>
        </>
      )}
    </StyledAccordion>
  );
};

Accordion.defaultProps = {
  open: false,
  header: null,
  children: null,
} as const;

export default Accordion;
